"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyConfigUnionMock = void 0;
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
exports.emptyConfigUnionMock = {
    AEs: [],
    AverageEnvironmentTemperatur: { Value: 20, Unit: '°C' },
    ChildRelation: undefined,
    Children: [],
    DomainVersion: '',
    Espool: undefined,
    FileRefs: [],
    Fuehrungsrinnen: [],
    IAs: [],
    IaArrangement: echain_shared_igus_fundamentals_1.IaArrangement.single,
    IgusGUIds: [],
    IsAlienConfiguration: false,
    IsIgnoreSafetyDistance: false,
    IsStackingOfLeitungenAllowed: false,
    Kette: undefined,
    Konfektionierungen: [],
    LeitungBomBehavior: echain_shared_articles_oo_1.LeitungBomBehavior.UseAll,
    Leitungen: [],
    MontBes: [],
    MontageSets: [],
    PdfRefs: [],
    QuoteCount: 1,
    SplitPositionX: undefined,
    UseSameIAColorAndMaterial: false,
    Verpackungen: [],
    Zugentlastungen: [],
};
//# sourceMappingURL=emptyConfigUnionMock.js.map